<div>
  <h6 class="text-secondary fw-bold">Información del funcionario que tomará el servicio</h6>

  <div class="d-flex flex-row-reverse" *ngIf="$viewButton">
    <div class="col-md-1">
      <button type="button" class="btn btn-secondary " (click)="openModal()">AGREGAR</button>
    </div>
  </div>

  <br>

  <div class="overflow-auto">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th scope="col">Primer nombre</th>
          <th scope="col">Segundo nombre</th>
          <th scope="col">Primer apellido</th>
          <th scope="col">Segundo apellido</th>
          <th scope="col">Télefono celular de contacto</th>
          <th scope="col">Correo electrónico</th>
          <th scope="col">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let pasajero of $pasajeros; let i = index">
          <td scope="row">{{ pasajero.vcPrimerNombre }}</td>
          <td>{{ pasajero.vcSegundoNombre }}</td>
          <td>{{ pasajero.vcPrimerApellido }}</td>
          <td>{{ pasajero.vcSegundoApellido }}</td>
          <td>{{ pasajero.vcTelefono }}</td>
          <td>{{ pasajero.vcCorreoElectronico }}</td>
          <td class="d-flex justify-content-center">
            <button type="button" class="btn btn-outline-secondary btn-sm" (click)="deleteFunct(i)" [disabled]="!$viewButton">
              <i class="fa-solid fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


<!-- ======================================================================================================= -->
<!-- ======================================================================================================= -->

<ng-template #modalRegister let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title text-secondary" id="staticBackdropLabel">
      <strong>Registro del funcionario para el servicio</strong>
    </h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="d('Cross click')"></button>
  </div>

  <div class="modal-body p-3">
    <div class="container">
      <form #registerFun="ngForm" (ngSubmit)="registerFun.form.valid && addRegOfficial()">
        <div class="row g-3 py-1">
          <div class="col-md-3">
            <label for="vcPrimerNombre" class="form-label">Primer nombre del funcionario<strong class="text-danger">*</strong></label>
            <input type="text" class="form-control" id="vcPrimerNombre" [(ngModel)]="solicitudPasajero.vcPrimerNombre" name="vcPrimerNombre"
                   #vcPrimerNombre="ngModel" maxlength="50" required (keydown)="isLetter($event)">

            <strong class="invalid-feedback d-block"
                    *ngIf="vcPrimerNombre.invalid && (vcPrimerNombre.dirty || vcPrimerNombre.touched || registerFun.submitted)">
              <span *ngIf="vcPrimerNombre.errors?.['required']">
                Campo obligatorio
              </span>
              <span *ngIf="vcPrimerNombre.errors?.['maxlength']">
                Máximo 50 caracteres
              </span>
            </strong>
          </div>

          <div class="col-md-3">
            <label for="vcSegundoNombre" class="form-label">Segundo nombre del funcionario</label>
            <input type="text" class="form-control" id="vcSegundoNombre" [(ngModel)]="solicitudPasajero.vcSegundoNombre" name="vcSegundoNombre"
                   #vcSegundoNombre="ngModel" maxlength="50" (keydown)="isLetterOrSpace($event)">
          </div>

          <div class="col-md-3">
            <label for="vcPrimerApellido" class="form-label">Primer apellido del funcionario<strong class="text-danger">*</strong></label>
            <input type="text" class="form-control" id="vcPrimerApellido" [(ngModel)]="solicitudPasajero.vcPrimerApellido" name="vcPrimerApellido"
                   #vcPrimerApellido="ngModel" maxlength="50" required (keydown)="isLetter($event)">

            <strong class="invalid-feedback d-block"
                    *ngIf="vcPrimerApellido.invalid && (vcPrimerApellido.dirty || vcPrimerApellido.touched || registerFun.submitted)">
              <span *ngIf="vcPrimerApellido.errors?.['required']">
                Campo obligatorio
              </span>
              <span *ngIf="vcPrimerNombre.errors?.['maxlength']">
                Máximo 50 caracteres
              </span>
            </strong>
          </div>

          <div class="col-md-3">
            <label for="vcSegundoApellido" class="form-label">Segundo apellido del funcionario</label>
            <input type="text" class="form-control" id="vcSegundoApellido" [(ngModel)]="solicitudPasajero.vcSegundoApellido" name="vcSegundoApellido"
                   #vcSegundoApellido="ngModel" maxlength="50" (keydown)="isLetterOrSpace($event)">
          </div>
        </div>


        <div class="row g-3 py-1">
          <div class="col-md-3">
            <label for="vcTelefono" class="form-label">Teléfono celular de contacto<strong class="text-danger">*</strong></label>
            <input type="text" class="form-control" id="vcTelefono" [(ngModel)]="solicitudPasajero.vcTelefono" name="vcTelefono" #vcTelefono="ngModel"
                   maxlength="10" required (keypress)="validateFormat($event)">

            <strong class="invalid-feedback d-block" *ngIf="vcTelefono.invalid && (vcTelefono.dirty || vcTelefono.touched || registerFun.submitted)">
              <span *ngIf="vcTelefono.errors?.['required']">
                Campo obligatorio
              </span>
              <span *ngIf="vcTelefono.errors?.['maxlength']">
                Máximo 10 caracteres
              </span>
            </strong>
          </div>

          <div class="col-md-3">
            <label for="vcCorreoElectronico" class="form-label">Correo electrónico<strong class="text-danger">*</strong></label>
            <input type="email" class="form-control" id="vcCorreoElectronico" [(ngModel)]="solicitudPasajero.vcCorreoElectronico"
                   name="vcCorreoElectronico" #vcCorreoElectronico="ngModel" pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,3}$" required>

            <strong class="invalid-feedback d-block"
                    *ngIf="vcCorreoElectronico.invalid && (vcCorreoElectronico.dirty || vcCorreoElectronico.touched || registerFun.submitted)">
              <span *ngIf="vcCorreoElectronico.errors?.['required']">
                Campo obligatorio
              </span>
              <span *ngIf="vcCorreoElectronico.errors?.['pattern']">
                Correo invalido
              </span>
            </strong>
          </div>
        </div>

        <br>

        <div class="container d-flex flex-row justify-content-end gap-2">
          <button class="btn btn-secondary col-3" type="submit">REGISTRAR</button>
          
          <button class="btn btn-secondary col-3" type="button" (click)="d('Cross click')">
            CANCELAR
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
